module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain2.27ad0e68.png";